import { Button, Collapse, Grid, List, ListItem } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React, { useState } from 'react';
import MobileAppRowHeader from './MobileAppRowHeader';

interface Props {
  idPrefix: string;
  mobileDeviceId: string;
  label: string;
  onDisconnect: (deviceId: string) => void;
  disconnectLoading: boolean;
}

const MobileAppRowConnected: React.FC<Props> = ({
  idPrefix,
  mobileDeviceId,
  label,
  onDisconnect,
  disconnectLoading
}) => {
  const { translation } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Grid container direction="column" spacing={0.5}>
      <MobileAppRowHeader
        id={`${idPrefix}-row`}
        label={label}
        statusLabel={translation.connected}
        statusColor="success"
        isExpandable
        isOpen={isOpen}
        onToggle={() => setIsOpen((previous) => !previous)}
      />
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <Grid container direction="row" wrap="nowrap" justifyContent="center" alignItems="center" width="100%">
          <List component="div" disablePadding>
            <ListItem>
              <Grid container direction="column">
                <Button
                  id={`${idPrefix}-disconnect-button`}
                  loading={disconnectLoading}
                  onClick={() => onDisconnect(mobileDeviceId)}
                  variant="outlined"
                  color="error"
                >
                  {translation.disconnect_device}
                </Button>
              </Grid>
            </ListItem>
          </List>
        </Grid>
      </Collapse>
    </Grid>
  );
};

export default MobileAppRowConnected;
